<template>

  <div>
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <b-col
            v-if="isMobile()"
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-space_between mb-1 mb-md-0"
          >
            <!-- <div class="bulk_selection d-flex">
              <div class="action-left pt-50">
                <b-form-checkbox
                  :checked="selectOpenPurchaseRequestCheckbox"
                  :indeterminate="isSelectOpenPurchaseRequestCheckboxIndeterminate"
                  @change="selectAllCheckboxUpdate"
                >
                  Select All
                </b-form-checkbox>
              </div>
              <b-dropdown
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="mx-1"
                right
                text="Bulk Actions"
                variant="primary"
                :disabled="!selectedPurchaseRequests.length"
              >
                <b-dropdown-item
                  v-if="canViewThisAction('update', 'PurchaseRequest')"
                  v-b-modal.modal-update-status-all-requests-bulk
                >
                  Update Status
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="canViewThisAction('delete', 'PurchaseRequest')"
                  @click="deleteBulkPurchaseRequests"
                >
                  Delete Purchase Request(s)
                </b-dropdown-item>
              </b-dropdown>
            </div> -->
            <span class="text-muted">Showing <br>{{ dataMeta.from }} - {{ dataMeta.to }} of {{ dataMeta.of }}</span>
          </b-col>
          <!-- Per Page -->
          <b-col
            v-else
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <!-- <div class="action-left pt-50">
              <b-form-checkbox
                :checked="selectOpenPurchaseRequestCheckbox"
                :indeterminate="isSelectOpenPurchaseRequestCheckboxIndeterminate"
                @change="selectAllCheckboxUpdate"
              >
                Select All
              </b-form-checkbox>
            </div>
            <b-dropdown
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class="mx-1"
              right
              text="Bulk Actions"
              variant="primary"
              :disabled="!selectedPurchaseRequests.length"
            >
              <b-dropdown-item
                v-if="canViewThisAction('update', 'PurchaseRequest')"
                v-b-modal.modal-update-status-open-service-form-bulk
              >
                Update Status
              </b-dropdown-item>
              <b-dropdown-item
                v-if="canViewThisAction('delete', 'PurchaseRequest')"
                @click="deleteBulkPurchaseRequests"
              >
                Delete Purchase Request(s)
              </b-dropdown-item>
            </b-dropdown> -->
            <span class="text-muted">Showing {{ dataMeta.from }} - {{ dataMeta.to }} of {{ dataMeta.of }}</span>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <a
                href="javascript:void(0)"
                class="nav-link nav-link-search"
                @click="showSearchBar = !showSearchBar"
              >
                <feather-icon
                  icon="SearchIcon"
                  size="21"
                  class="mr-50"
                />
                <span class="align-middle">Search</span>
              </a>
              <b-input-group
                v-if="showSearchBar"
                class="input-group-merge mr-50"
              >
                <b-form-input
                  v-model="searchQuery"
                  placeholder="Search..."
                />
                <b-input-group-append is-text>
                  <feather-icon
                    icon="XIcon"
                    class="cursor-pointer"
                    @click="searchQuery = ''; showSearchBar = !showSearchBar"
                  />
                </b-input-group-append>
              </b-input-group>

              <b-dropdown
                id="dropdown-form-purchase-request"
                ref="filter_dropdown_open_my_purchase_request"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="dropdown-modal"
                right
                variant="link"
              >
                <template #button-content>
                  <feather-icon
                    icon="FilterIcon"
                    size="21"
                    class="align-middle mr-50"
                  />
                  <span class="mr-1">Filters</span>
                </template>
                <purchase-request-filters
                  :stage-filter.sync="stageFilter"
                  :created-at.sync="createdAtFilter"
                  :invoice-filter.sync="invoiceFilter"
                  :invoice-options="invoiceOptions"
                  :stage-options="stageOptions"
                  :vendor.sync="vendor"
                  :vendor-options="vendorOptions"
                  :entity.sync="entity"
                  :entity-options="businessEntityOptions"
                  :requestor.sync="requestorFilter"
                  :requestor-options="requestorOptions"
                  @emitHideFilter="hideFilter"
                  @emitShowFilter="showFilter"
                />
              </b-dropdown>
            </div>
          </b-col>
        </b-row>
        <div v-if="createdAtFilter || requestorFilter.length || invoiceFilter.length || statusFilter.length">
          <hr class="dividerHR filter-divider">
          <b-row>

            <!-- Per Page -->
            <b-col
              cols="12"
              md="12"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <ul
                class="list-inline d-inline-block mb-1"
              >
                <li
                  v-if="createdAtFilter"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="createdAtFilter = ''"
                  >
                    {{ createdAtFilter }}
                  </b-form-tag>
                </li>
                <li
                  v-for="invoiceVal in invoiceFilter"
                  :key="invoiceVal"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromInvoiceFilter(invoiceVal)"
                  >
                    <span class="text-capitalize">Invoice Attached - {{ invoiceVal }}</span>
                  </b-form-tag>
                </li>
                <li
                  v-for="requestorVal in requestorFilter"
                  :key="requestorVal"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromRequestorFilter(requestorVal)"
                  >
                    <span class="text-capitalize">{{ resolveRequestorName(requestorVal) }}</span>
                  </b-form-tag>
                </li>
                <li
                  class="list-inline-item"
                >
                  <span
                    class="text-danger clear-filter-text mb-50"
                    @click="clearAllFilters"
                  >
                    Clear Filters
                  </span>
                </li>
              </ul>
            </b-col>
          </b-row>
        </div>
      </div>

      <b-table
        ref="refOpenPurchaseRequestsTable"
        class="position-relative event_list"
        :class="{ low_items: purchaseRequestData.length < 4 }"
        :items="fetchPurchaseRequests"
        responsive
        :fields="tableColumns"
        primary-key="_id"
        :sort-by.sync="sortBy"
        show-empty
        no-sort-reset
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- Column: Role -->
        <template #cell(stringID)="data">
          <div class="text-nowrap">
            <b-button
              v-if="canViewThisAction('show', 'PurchaseRequest') || canViewThisAction('my-request-show', 'MyPurchaseRequest') || canViewThisAction('my-department-request-view', 'MyPurchaseRequest')"
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="link"
              class="weight-600 align-middle detail-view-id"
              :to="{ name: 'purchasing-purchase-request-show', params: { id: data.item._id }, query: { from: 'my-pr' } }"
            >
              {{ data.item.caseID }}
            </b-button>
            <b-button
              v-else
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="none"
              class="text-bold-black align-middle detail-view-id not-button"
            >
              {{ data.item.caseID }}
            </b-button>
            <br>
            <span
              v-if="data.item.stage == 'in-order' || data.item.stage == 'in-delivery'"
              class="text-bold-black detail-view-id"
            >
              {{ data.item.prID }}
            </span>
          </div>
        </template>

        <template #cell(receivedDate)="data">
          <div class="text-nowrap">
            <span class="">{{ data.item.receivedDate ? dateFormatWithTime(data.item.receivedDate) : '' }}</span>
          </div>
        </template>

        <template #cell(purpose)="data">
          <div class="">
            <span class="">{{ data.item.purpose }}</span>
          </div>
        </template>

        <template #cell(requester)="data">
          <div class="text-nowrap">
            <span class="">{{ data.item.createdBy.name }}</span>
          </div>
        </template>

        <template #cell(vendor)="data">
          <div class="text-nowrap">
            <span class="">{{ data.item.vendor ? data.item.vendor.companyName : '' }}</span>
          </div>
        </template>

        <template #cell(company)="data">
          <div class="text-nowrap">
            <span class="">{{ data.item.company ? data.item.company.name : '' }}</span>
          </div>
        </template>

        <template #cell(invoices)="data">
          <div
            v-for="invoice in data.item.invoices"
            :key="invoice._id"
            class="text-nowrap"
          >
            <div v-if="canViewThisAction('show', 'VendorPayment')">
              <b-button
                variant="link"
                class="p-0 weight-600"
                :to="{ name: 'purchasing-vendor-payment-single-view', params: { id: invoice._id }, query: { from: 'my-vp' } }"
              >
                {{ invoice.invoiceID }}
              </b-button>
            </div>
            <div v-else>
              <span>{{ invoice.invoiceID }}</span>
            </div>
          </div>
        </template>

        <template #cell(pendingSignatory)="data">
          <div class="text-nowrap">
            <span class="">{{ data.item.pendingSignatory ? data.item.pendingSignatory.name : '-' }}</span>
          </div>
        </template>

        <template #cell(assignedTo)="data">
          <div class="text-nowrap">
            <span class="">{{ data.item.assignedTo ? data.item.assignedTo.name : '' }}</span>
          </div>
        </template>

        <!-- Column: Status -->
        <template #cell(stage)="data">
          <b-badge
            :variant="`light-${resolvePurchaseRequestStageVariant(data.item.stage)}`"
            class="text-capitalize"
          >
            <feather-icon
              :icon="resolveRequestStageIcon(data.item.stage)"
              size="24"
              class="align-middle text-body"
            />
            {{ resolveRequestStageName(data.item.stage) }}
          </b-badge>
        </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge
            :variant="`light-${resolvePurchaseRequestStatusVariant(data.item.status)}`"
            class="text-capitalize"
          >
            {{ data.item.status }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template
          v-if="canViewThisAction('show', 'PurchaseRequest') || canViewThisAction('my-request-show', 'MyPurchaseRequest') || canViewThisAction('my-department-request-view', 'MyPurchaseRequest') || canViewThisAction('update', 'PurchaseRequest') || canViewThisAction('delete', 'PurchaseRequest')"
          #cell(actions)="data"
        >
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              v-if="canViewThisAction('show', 'PurchaseRequest') || canViewThisAction('my-request-show', 'MyPurchaseRequest') || canViewThisAction('my-department-request-view', 'MyPurchaseRequest')"
              :to="{ name: 'purchasing-purchase-request-show', params: { id: data.item._id }, query: { from: 'my-pr' } }"
            >
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50">View</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="data.item.status != 'cancelled' && data.item.stage != 'in-delivery' && (canViewThisAction('cancel', 'PurchaseRequest') || user._id == (data.item.createdBy ? data.item.createdBy._id : ''))"
              @click="showCancelWarning(data.item._id, data.item.caseID)"
            >
              <feather-icon icon="XCircleIcon" />
              <span class="align-middle ml-50">Cancel Purchase Request</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
    </b-card>

    <div
      v-if="totalPurchaseRequests > perPage"
      class="mx-2 mb-2"
    >
      <b-row>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="12"
          class="d-flex align-items-center justify-content-center pagination-content"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="totalPurchaseRequests"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            align="center"
            prev-text="Prev"
            next-text="Next"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
              <span>Prev</span>
            </template>
            <template #next-text>
              <span>Next</span>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>

    <b-modal
      id="modal-update-status-open-service-form-bulk"
      ref="update-status-modal-open-bulk"
      modal-class="status-update-modal"
      cancel-variant="flat-primary"
      ok-variant="success"
      ok-title="Update"
      cancel-title="Cancel"
      centered
      no-close-on-backdrop
      title="Update Status"
      @ok="updateBulkStatus"
    >
      <b-form @submit.prevent="updateBulkStatus">
        <validation-observer
          ref="openMyPurchaseRequestsBulkStatusEditForm"
        >
          <b-form-group
            label="Status*"
            label-for="h-event-status"
          >
            <validation-provider
              #default="{ errors }"
              name="Status"
              vid="status"
              rules="required"
            >
              <v-select
                id="h-event-status"
                v-model="bulkStatus"
                label="title"
                :options="statusDataOptions"
                :reduce="title => title.code"
                :clearable="false"
                @input="bulkStatusValidation == true ? bulkStatusValidation = false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
              <small
                v-if="bulkStatusValidation"
                class="text-danger"
              >
                {{ bulkStatusError }}
              </small>
            </validation-provider>
          </b-form-group>
        </validation-observer>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BRow, BCol, BFormInput, BTable, BInputGroup, BInputGroupAppend,
  BBadge, BDropdown, BDropdownItem, BPagination, BForm, BFormGroup, BButton, BFormTag,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { ref, onUnmounted, computed } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useUtils as useAclUtils } from '@/libs/acl/custom'

import store from '@/store'

import useOpenMyPurchaseRequestList from './useOpenMyPurchaseRequestList'
import purchaseRequestStoreModule from '../purchaseRequestStoreModule'
import PurchaseRequestFilters from '../PurchaseRequestFilters.vue'

export default {
  components: {
    // UserListAddNew,
    BButton,
    BForm,
    BFormGroup,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BInputGroup,
    BInputGroupAppend,
    BFormTag,

    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    vSelect,

    PurchaseRequestFilters,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    businessEntityOptions: {
      type: Array,
      required: true,
    },
    vendorOptions: {
      type: Array,
      required: true,
    },
    requestorOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      user: store.state.auth.userData,
      bulkStatus: 'pending approval',
      bulkStatusValidation: false,
      bulkStatusError: 'Valid status is required',
      statusDataOptions: [
        { title: 'Draft', code: 'draft' },
        { title: 'Pending Edit', code: 'pending edit' },
        { title: 'Pending Approval', code: 'pending approval' },
        { title: 'Verifying', code: 'verifying' },
        { title: 'Verified', code: 'verified' },
        { title: 'Cancelled', code: 'cancelled' },
      ],
      showFilterDropdown: process.env.VUE_APP_SHOW_FILTER_DROPDOWN,

      required,
    }
  },

  methods: {
    hideFilter() {
      this.$refs.filter_dropdown_open_my_purchase_request.hide(true)
    },
    showFilter() {
      this.$refs.filter_dropdown_open_my_purchase_request.show(true)
    },
    removeFromStatusFilter(item) {
      const index = this.statusFilter.indexOf(item)
      if (index > -1) {
        this.statusFilter.splice(index, 1)
      }
    },
    removeFromInvoiceFilter(item) {
      const index = this.invoiceFilter.indexOf(item)
      if (index > -1) {
        this.invoiceFilter.splice(index, 1)
      }
    },

    removeFromRequestorFilter(item) {
      const index = this.requestorFilter.indexOf(item)
      if (index > -1) {
        this.requestorFilter.splice(index, 1)
      }
    },
    resolveRequestorName(id) {
      const user = this.requestorOptions.find(o => o._id === id)
      if (user) {
        return user.name || ''
      }
      return ''
    },

    clearAllFilters() {
      this.createdAtFilter = ''
      this.stageFilter = []
      this.vendor = []
      this.entity = []
      this.requestorFilter = []
      this.invoiceFilter = []
    },
    resolveRequestStageIcon(stage) {
      let icon = 'AlignCenterIcon'
      if (stage === 'in-request') {
        icon = 'BoxIcon'
      } else if (stage === 'in-quotation') {
        icon = 'ClipboardIcon'
      } else if (stage === 'in-order') {
        icon = 'BoxIcon'
      } else if (stage === 'in-delivery') {
        icon = 'TruckIcon'
      }

      return icon
    },
    resolveRequestStageName(stage) {
      let name = 'PR'
      if (stage === 'in-request') {
        name = 'PR'
      } else if (stage === 'in-quotation') {
        name = 'QCF'
      } else if (stage === 'in-order') {
        name = 'PO'
      } else if (stage === 'in-delivery') {
        name = 'DR'
      }

      return name
    },
    updateBulkStatus() {
      this.$refs.openMyPurchaseRequestsBulkStatusEditForm.validate().then(success => {
        if (success) {
          const formData = new FormData()
          formData.append('status', this.bulkStatus)
          // eslint-disable-next-line no-plusplus
          for (let i = 0; i < this.selectedPurchaseRequests.length; i++) {
            formData.append('purchaseRequests[]', this.selectedPurchaseRequests[i])
          }

          this.$http.patch('purchase/purchase-request/action/bulk/status/update', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
            .then(() => {
              this.refetchData()
              this.$emit('emitCountMyPurchaseRequest')
              this.$swal({
                title: 'Status Updated!',
                html: 'The status for selected purchase requests has been updated',
                // eslint-disable-next-line global-require
                imageUrl: require('@/assets/images/icons/save.png'),
                imageWidth: 80,
                imageHeight: 80,
                imageAlt: 'Custom Icon',
                showCancelButton: false,
                confirmButtonText: 'Okay',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
              })
            })
            .catch(error => {
              if (error.data.errors) {
                error.data.errors.forEach(validationError => {
                  if (validationError.param === 'bulkStatus') {
                    this.bulkStatusError = validationError.msg
                    this.bulkStatusValidation = true
                  }
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
        }
      })
    },
    showCancelWarning(id, caseID) {
      this.$swal({
        title: 'Are You Sure?',
        html: 'Cancelling this Purchase Request will freeze this Purchase Request. You will no longer be able to edit this Purchase Request.<br><br><span class="text-bold-black">This action cannot be undone.</span>',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/warning.png'),
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'No, go back',
        confirmButtonText: 'Yes, cancel this PR',
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            this.$http.post(`purchase/purchase-request/${id}/cancel`, {})
              .then(() => {
                this.refetchData()
                this.$swal({
                  title: 'Purchase Request Cancelled!',
                  html: `Purchase Request <strong>${caseID}</strong> has been cancelled`,
                  // eslint-disable-next-line global-require
                  imageUrl: require('@/assets/images/icons/success.png'),
                  imageWidth: 80,
                  imageHeight: 80,
                  imageAlt: 'Custom Icon',
                  showCancelButton: false,
                  confirmButtonText: 'Okay',
                  customClass: {
                    confirmButton: 'btn btn-primary',
                  },
                  buttonsStyling: false,
                })
              })
              .catch(error => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              })
          }
        })
    },
    deleteBulkPurchaseRequests() {
      this.$swal({
        title: 'Are you sure?',
        html: 'This will <strong>delete</strong> selected purchase request(s). This action cannot be undone.',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/warning.png'),
        imageWidth: 80,
        imageHeight: 80,
        imageAlt: 'Custom Icon',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: 'Yes, Delete!',
        cancelButtonText: 'No, Go Back',
        customClass: {
          confirmButton: 'btn btn-danger ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            const formData = new FormData()
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < this.selectedPurchaseRequests.length; i++) {
              formData.append('purchaseRequests[]', this.selectedPurchaseRequests[i])
            }

            this.$http.patch('purchase/purchase-request/action/bulk/delete', formData, {
              headers: { 'Content-Type': 'multipart/form-data' },
            })
              .then(() => {
                this.refetchData()
                this.$emit('emitCountMyPurchaseRequest')
                this.selectedPurchaseRequests = []
                // this.$nextTick(() => {
                //   this.$refs['update-status-modal'].toggle('#toggle-btn')
                // })
                this.$swal({
                  title: 'Purchase Request(s) Deleted!',
                  html: 'Selected purchase request(s) has been deleted',
                  // eslint-disable-next-line global-require
                  imageUrl: require('@/assets/images/icons/save.png'),
                  imageWidth: 80,
                  imageHeight: 80,
                  imageAlt: 'Custom Icon',
                  showCancelButton: false,
                  confirmButtonText: 'Okay',
                  customClass: {
                    confirmButton: 'btn btn-primary',
                  },
                  buttonsStyling: false,
                })
              })
              .catch(error => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              })
          }
        })
    },
    deleteEntity(id) {
      this.$swal({
        title: 'Are You Sure?',
        html: 'Selecting Delete will <strong>permanently delete</strong> this item. This action cannot be undone.',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/warning.png'),
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'No, Cancel',
        confirmButtonText: 'Yes, Delete!',
        customClass: {
          confirmButton: 'btn btn-danger ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            this.toDeletedID = id
            this.deletePurchaseRequest()
          }
        })
    },
  },
  setup() {
    const showSearchBar = ref(false)
    const showFilterOptions = ref(false)
    const PURCHASE_REQUEST_APP_STORE_MODULE_NAME = 'app-open-my-purchase-request'

    // Register module
    if (!store.hasModule(PURCHASE_REQUEST_APP_STORE_MODULE_NAME)) store.registerModule(PURCHASE_REQUEST_APP_STORE_MODULE_NAME, purchaseRequestStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(PURCHASE_REQUEST_APP_STORE_MODULE_NAME)) store.unregisterModule(PURCHASE_REQUEST_APP_STORE_MODULE_NAME)
    })

    const stageOptions = [
      { title: 'Purchase Request', code: 'in-request' },
      { title: 'Purchase Order', code: 'in-order' },
      { title: 'Quotation Sourcing', code: 'in-quotation' },
      { title: 'Delivery', code: 'in-delivery' },
      { title: 'Non-Conformance', code: 'in-ncf' },
    ]

    const statusOptions = [
      { title: 'Draft', code: 'draft' },
      { title: 'Pending Edit', code: 'pending edit' },
      { title: 'Pending Approval', code: 'pending approval' },
      { title: 'Verifying', code: 'verifying' },
      { title: 'Verified', code: 'verified' },
      { title: 'Cancelled', code: 'cancelled' },
    ]

    const invoiceOptions = [
      { title: 'Yes', code: 'Yes' },
      { title: 'No', code: 'No' },
    ]

    const { canViewThisAction } = useAclUtils()

    const {
      fetchPurchaseRequests,
      tableColumns,
      perPage,
      currentPage,
      totalPurchaseRequests,
      purchaseRequestData,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refOpenPurchaseRequestsTable,
      refetchData,

      toDeletedID,
      deletePurchaseRequest,

      // UI
      resolvePurchaseRequestStatusVariant,
      resolvePurchaseRequestStageVariant,

      // Extra Filters
      statusFilter,
      stageFilter,
      invoiceFilter,
      entity,
      vendor,
      createdAtFilter,
      requestorFilter,
    } = useOpenMyPurchaseRequestList()

    const selectedPurchaseRequests = ref([])
    const toggleSelectedPurchaseRequests = PurchaseRequestId => {
      const PurchaseRequestIndex = selectedPurchaseRequests.value.indexOf(PurchaseRequestId)

      if (PurchaseRequestIndex === -1) selectedPurchaseRequests.value.push(PurchaseRequestId)
      else selectedPurchaseRequests.value.splice(PurchaseRequestIndex, 1)
    }
    const selectOpenPurchaseRequestCheckbox = computed(() => purchaseRequestData.value.length && (purchaseRequestData.value.length === selectedPurchaseRequests.value.length))
    const isSelectOpenPurchaseRequestCheckboxIndeterminate = computed(() => Boolean(selectedPurchaseRequests.value.length) && purchaseRequestData.value.length !== selectedPurchaseRequests.value.length)
    const selectAllCheckboxUpdate = val => {
      selectedPurchaseRequests.value = val ? purchaseRequestData.value.map(flow => flow._id) : []
    }

    return {

      // Sidebar

      fetchPurchaseRequests,
      tableColumns,
      perPage,
      currentPage,
      totalPurchaseRequests,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refOpenPurchaseRequestsTable,
      refetchData,
      showSearchBar,
      showFilterOptions,
      toDeletedID,
      deletePurchaseRequest,
      purchaseRequestData,

      // Filter
      avatarText,
      canViewThisAction,

      // UI
      resolvePurchaseRequestStatusVariant,
      resolvePurchaseRequestStageVariant,

      statusOptions,
      stageOptions,
      invoiceOptions,

      // Extra Filters
      statusFilter,
      stageFilter,
      invoiceFilter,
      entity,
      vendor,
      createdAtFilter,
      requestorFilter,

      selectOpenPurchaseRequestCheckbox,
      isSelectOpenPurchaseRequestCheckboxIndeterminate,
      selectedPurchaseRequests,
      toggleSelectedPurchaseRequests,
      selectAllCheckboxUpdate,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
